import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { resolveContentCountry, type ContentCountry } from "@/lib/learnerCountry";

export function useLearnerCountry() {
  const { user } = useAuth();
  const [country, setCountry] = useState<ContentCountry>("IN");
  const [source, setSource] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;
    let alive = true;
    supabase
      .from("profiles")
      .select("content_country,content_country_source,country,country_code")
      .eq("id", user.id)
      .maybeSingle()
      .then(({ data }) => {
        if (!alive) return;
        setCountry(resolveContentCountry(data));
        setSource(data?.content_country_source ?? null);
      });
    return () => { alive = false; };
  }, [user]);

  const change = useCallback(async (c: ContentCountry) => {
    const { error } = await supabase.rpc("set_my_content_country", { _country: c });
    if (error) throw error;
    setCountry(c);
    setSource("manual");
  }, []);

  return { country, source, setCountry: change };
}
